<template>
  <f7-page name="config-inputs" ref="page">
    <f7-progressbar v-if="isLoading || isLoadingSSP || isLoadingAssetData" infinite color="green" class="progressbar-top"></f7-progressbar>
    <f7-navbar :sliding="false">
      <f7-nav-left back-link="Back">
      </f7-nav-left>
      <f7-nav-title sliding>{{ $t('ConfigInputs') }}</f7-nav-title>
      <f7-nav-right>
        <label :for="inputSubmitId" v-if="isInput1Showed || isInput2Showed" class="link icon-only">
          <i class="icon f7-icons">checkmark_alt</i>
        </label>
      </f7-nav-right>
    </f7-navbar>

    <f7-list v-if="isLoadingSSP || isLoadingAssetData" class="skeleton-text skeleton-effect-wave" key="assetLoadSkeleton">
      <f7-list-item
          v-for="n in 4"
          :key="n"
          header="Header"
          title="Title"
      >
        <template #media>
          <f7-skeleton-block
              style="width: 40px; height: 40px; border-radius: 50%"
          ></f7-skeleton-block>
        </template>
      </f7-list-item>
    </f7-list>

    <form v-else action="" @submit.prevent="onSubmit">
      <input type="submit" :id="inputSubmitId" hidden >

      <f7-block-title>{{$t('AssetDetails')}}</f7-block-title>
      <f7-list>
        <f7-list-item :title="TargetAsset.IMEI" :header="$t('IMEI')">
          <template #media>
            <f7-icon icon="f7-icons text-color-lightgray icon-number"></f7-icon>
          </template>
        </f7-list-item>
        <f7-list-item :title="TargetAsset.SimNO" :header="$t('IMSI')">
          <template #media>
            <f7-icon icon="f7-icons text-color-lightgray icon-other-imei"></f7-icon>
          </template>
        </f7-list-item>
        <f7-list-item :title="TargetAsset.Product" :header="$t('DeviceType')">
          <template #media>
            <f7-icon icon="f7-icons text-color-lightgray "></f7-icon>
          </template>
        </f7-list-item>
        <f7-list-item :title="TargetAsset.Solution" :header="$t('SolutionType')">
          <template #media>
            <f7-icon :icon="`f7-icons text-color-lightgray ${solutionTypeIcon}`"></f7-icon>
          </template>
        </f7-list-item>
      </f7-list>

      <f7-block v-if="!isInput1Showed && !isInput2Showed">
        <p>{{$t('NoInputsToConfigure')}}</p>
      </f7-block>

      <f7-block-title v-if="isInput1Showed">{{$t('INPUT1')}}</f7-block-title>
      <f7-list v-if="isInput1Showed" class="no-hairline-bottom">
        <f7-list-item
            class="item-input custom-smart-select-wrapper col-100"
            :title="$t('Input1Name')"
            smart-select
            :smart-select-params="{openIn: 'popup', searchbar: true, closeOnSelect: true, formColorTheme: 'green' }"
            :key="'keyInput1Name'+keyInputNamesList"
            :class="{'disabled': isLoadingSSP}"
        >
          <template #media>
            <f7-icon slot="media" :icon="`f7-icons text-color-lightgray icon-${ input1Icon }`"></f7-icon>
          </template>
          <select name="Input1Name" v-model="Input1Name">
            <option
                v-for="inputType in InputsTypeList"
                :key="inputType.code"
                :value="inputType.code"
                :data-option-icon="`f7-icons text-color-lightgray icon-${ inputType.icon }`"
            >{{inputType.name}}</option>
          </select>
        </f7-list-item>
        <f7-list-item
            class="item-input custom-smart-select-wrapper"
            :title="$t('MaskTime')"
            smart-select
            :smart-select-params="{openIn: 'popover', closeOnSelect: true, formColorTheme: 'green' }"
            :key="'keyMask1TimeList'+keyMaskTimeList"
        >
          <template #media>
            <f7-icon slot="media" icon="f7-icons text-color-lightgray"></f7-icon>
          </template>
          <select name="MaskTimeList" v-model="Input1Mask">
            <option
                v-for="type in InputsMaskTimeList"
                :key="type.code"
                :value="type.code"
            >{{type.name}}</option>
          </select>
        </f7-list-item>
        <f7-list-item
            class="item-input custom-smart-select-wrapper"
            :title="$t('Type')"
            smart-select
            :smart-select-params="{openIn: 'popover', closeOnSelect: true, formColorTheme: 'green' }"
            :key="'keyInput1VeList'+keyInputVeList"
        >
          <template #media>
            <f7-icon slot="media" icon="f7-icons text-color-lightgray"></f7-icon>
          </template>
          <select name="Input1VeType" v-model="Input1Type">
            <option
                v-for="type in InputsVeTypeList"
                :key="type.code"
                :value="type.code"
            >{{type.name}}</option>
          </select>
        </f7-list-item>
      </f7-list>

      <f7-block-title v-if="isInput2Showed">{{$t('INPUT2')}}</f7-block-title>
      <f7-list v-if="isInput2Showed" class="no-hairline-bottom">
        <f7-list-item
            class="item-input custom-smart-select-wrapper col-100"
            :title="$t('Input2Name')"
            smart-select
            :smart-select-params="{openIn: 'popup', searchbar: true, closeOnSelect: true, formColorTheme: 'green' }"
            :key="'keyInput2Name'+keyInputNamesList"
            :class="{'disabled': isLoadingSSP}"
        >
          <template #media>
            <f7-icon slot="media" :icon="`f7-icons text-color-lightgray icon-${ input2Icon }`"></f7-icon>
          </template>
          <select name="Input2Name" v-model="Input2Name">
            <option
                v-for="inputType in InputsTypeList"
                :key="inputType.code"
                :value="inputType.code"
                :data-option-icon="`f7-icons text-color-lightgray icon-${ inputType.icon }`"
            >{{inputType.name}}</option>
          </select>
        </f7-list-item>
        <f7-list-item
            class="item-input custom-smart-select-wrapper"
            :title="$t('MaskTime')"
            smart-select
            :smart-select-params="{openIn: 'popover', closeOnSelect: true, formColorTheme: 'green' }"
            :key="'keyMask2TimeList'+keyMaskTimeList"
        >
          <template #media>
            <f7-icon slot="media" icon="f7-icons text-color-lightgray"></f7-icon>
          </template>
          <select name="MaskTimeList" v-model="Input2Mask">
            <option
                v-for="type in InputsMaskTimeList"
                :key="type.code"
                :value="type.code"
            >{{type.name}}</option>
          </select>
        </f7-list-item>
        <f7-list-item
            class="item-input custom-smart-select-wrapper"
            :title="$t('Type')"
            smart-select
            :smart-select-params="{openIn: 'popover', closeOnSelect: true, formColorTheme: 'green' }"
            :key="'keyInput2VeList'+keyInputVeList"
        >
          <template #media>
            <f7-icon slot="media" icon="f7-icons text-color-lightgray"></f7-icon>
          </template>
          <select name="Input1VeType" v-model="Input2Type">
            <option
                v-for="type in InputsVeTypeList"
                :key="type.code"
                :value="type.code"
            >{{type.name}}</option>
          </select>
        </f7-list-item>
      </f7-list>

    </form>
  </f7-page>
</template>

<script>
import {mapGetters} from "vuex";
import {
  getInputsTypes,
  getInputTypeIcon,
  getInputMaskTimes,
  getInputVeTypes,
  ProductFeaturesEnum,
  getSolutionTypeIcon
} from "../../../js/helpers";
import {QTAPI} from "../../../services/qt-api";
import {f7} from "framework7-vue";

export default {
  name: "config-inputs",

  data(){
    return {
      inputSubmitId: f7.utils.id(),

      isLoading: false,
      isLoadingSSP: false,
      isLoadingAssetData: false,

      keyInputNamesList: 1,
      keyMaskTimeList: 1,
      keyInputVeList: 1,

      InputsTypeList: getInputsTypes(),
      InputsMaskTimeList: getInputMaskTimes(),
      InputsVeTypeList: getInputVeTypes(),
      ProductList: [],
      SolutionTypeList: [],

      ProductCode: null,
      SolutionCode: null,
      Input1Name: null,
      Input1Mask: null,
      Input1Type: null,
      Input2Name: null,
      Input2Mask: null,
      Input2Type: null,
    }
  },

  computed: {
    ...mapGetters(['MajorToken', 'MinorToken', 'TargetAsset']),

    isInput1Showed(){
      let ret = false
      if(!this.ProductCode && !this.ProductList.length){
        return ret
      }

      let productObg = this.ProductList.find( (item) => item.Code === this.ProductCode )
      if(!productObg){
        return ret
      }

      let solutionObj = this.SolutionTypeList.find( (item) => item.Code === this.SolutionCode )
      if(!solutionObj){
        return ret
      }

      return (parseInt(productObg.Features) & ProductFeaturesEnum.Input1) > 0 &&
          solutionObj.Features && solutionObj.Features.indexOf("IO,") >= 0
    },
    isInput2Showed(){
      let ret = false
      if(!this.ProductCode && !this.ProductList.length){
        return ret
      }

      let productObg = this.ProductList.find( (item) => item.Code === this.ProductCode )
      if(!productObg){
        return ret
      }

      let solutionObj = this.SolutionTypeList.find( (item) => item.Code === this.SolutionCode )
      if(!solutionObj){
        return ret
      }

      return (parseInt(productObg.Features) & ProductFeaturesEnum.Input2) > 0 &&
          solutionObj.Features && solutionObj.Features.indexOf("IO,") >= 0
    },
    input1Icon(){
      return getInputTypeIcon(this.Input1Name)
    },
    input2Icon(){
      return getInputTypeIcon(this.Input2Name)
    },
    solutionTypeIcon(){
      return getSolutionTypeIcon(this.TargetAsset.Solution)
    }
  },

  mounted() {
    this.getSSP();
    this.getAssetInfo();
  },

  methods: {
    async onSubmit(){

      this.isLoading = true;
      let result = await QTAPI.SetInputConfig({
        MinorToken: this.MajorToken,

        IMEI: this.TargetAsset.IMEI,
        Input1Name: this.Input1Name,
        Input1Mask: this.Input1Mask,
        Input1Type: this.Input1Type,
        Input2Name: this.Input2Name,
        Input2Mask: this.Input2Mask,
        Input2Type: this.Input2Type,

        MobileToken: localStorage.PUSH_MOBILE_TOKEN,
        AppKey: localStorage.PUSH_APP_KEY,
        Token: localStorage.PUSH_DEVICE_TOKEN,
        Type: localStorage.DEVICE_TYPE,

      })
      this.isLoading = false;
      if(!result){
        return
      }
      f7.notification.create({
        subtitle: this.$t('Success'),
        text: this.$t('DataUpdated'),
      }).open()
      f7.views.main.router.back()
    },


    async getSSP(){
      this.isLoadingSSP = true;
      let ssp = await QTAPI.GetSSP({ DealerToken: this.MajorToken })
      this.isLoadingSSP = false;
      if(!ssp){
        return
      }
      this.ProductList = ssp.Products
      this.SolutionTypeList = ssp.Solutions
    },
    async getAssetInfo(){
      this.isLoadingAssetData = true
      let result = await QTAPI.GetAssetInfo({majortoken: this.MajorToken, imeis: this.TargetAsset.IMEI})
      this.isLoadingAssetData = false
      if(!result){
        return
      }

      this.ProductCode = result.ProductCode
      this.SolutionCode = result.Solution

      this.Input1Name = result.Input1Name
      this.Input1Mask = result.Input1Mask
      this.Input1Type = result.Input1Type
      this.Input2Name = result.Input2Name
      this.Input2Mask = result.Input2Mask
      this.Input2Type = result.Input2Type

    }
  }
}
</script>

<style scoped>

</style>